'use client';
import { useConstant } from '@cc-shopping/hooks/useConstant';
// TODO: If this becomes an RSC, fix the window check below
import { AnalyticsLinkViewed } from '@cc-shopping/platform-analytics/AnalyticsLinkViewed';
import { useAnalyticsPageView } from '@cc-shopping/platform-analytics/AnalyticsPageView/Context';
import { useAnalytics } from '@cc-shopping/platform-analytics/hooks/useAnalytics';
import { Link, Typography, type TypographyProps } from '@mui/material';
import { v4 as uuid } from 'uuid';

export const SeeAllReviews = ({ ...props }: Partial<TypographyProps>) => {
  const linkViewedEventId = useConstant(() => uuid());

  const { analytics, deployableName, deployableVersion, gitSha } = useAnalytics();
  const { pageViewId } = useAnalyticsPageView();

  const { sx: sxProps, ...rest } = props;
  const linkHref = '/h/category/credit-card-reviews';
  const destinationUrl = `${typeof window !== 'undefined' && window.location.origin}${linkHref}`;
  const linkCopy = 'See all of our credit card reviews';

  const fireClickEvent = () => {
    if (analytics) {
      void analytics.track(
        'link_clicked',
        {
          deployable_name: deployableName,
          deployable_version: deployableVersion,
          destination_url: destinationUrl,
          entity_name: 'link',
          event_id: uuid(),
          link_copy: linkCopy,
          impression_pageview_id: pageViewId,
          parent_event_id: linkViewedEventId,
        },
        {
          context: {
            app: {
              name: deployableName,
              version: gitSha,
            },
          },
        },
      );
    }
  };

  return (
    <AnalyticsLinkViewed
      destinationUrl={destinationUrl}
      linkCopy={linkCopy}
      event_id={linkViewedEventId}
    >
      <Typography variant="textBold" sx={{ ...sxProps }} {...rest}>
        See all of our{' '}
        <Link href={linkHref} onClick={fireClickEvent} color="blues.main">
          credit card reviews
        </Link>
        .
      </Typography>
    </AnalyticsLinkViewed>
  );
};
